/**
 * @generated SignedSource<<dfd15ceaab49637c6032d2a6fd487019>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemPrice_displayPrice$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"useItemPriceData_displayPrice">;
  readonly " $fragmentType": "ItemPrice_displayPrice";
}>;
export type ItemPrice_displayPrice$key = ReadonlyArray<{
  readonly " $data"?: ItemPrice_displayPrice$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemPrice_displayPrice">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ItemPrice_displayPrice",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_displayPrice"
    }
  ],
  "type": "ItemDisplayPriceType",
  "abstractKey": null
};

(node as any).hash = "0e4e4e4ce65974bf8337e471aa08615b";

export default node;
